module.exports = __webpack_public_path__ + "static/media/ios-add-circle.25f2a81b.svg";